module.exports = __webpack_public_path__ + "img/w3_button_close_white.36e223a1.png";